module.exports = __webpack_public_path__ + "static/media/Rectangle 7.c896ee45.jpg";